// not part of schema, used in stories
export const DividerNode = () => {
  return <hr style={{ width: '100%' }} />
}
